import React, { Component } from 'react';
import Modal from 'react-responsive-modal';

const style = {
  overlay: {

  },

  modal: {
    minWidth: "500px",
    borderRadius: "15px",
    overflow: "auto",
    border: "5px solid #CCCCCC",
  },

  closeButton: {

  },

  closeIcon: {

  },
}

class LocationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    }
  }

  openModal = () => {
    this.setState({isOpen: true});
  }

  closeModal = () => {
    this.setState({isOpen: false});
  }

  render = () => {
    return (
      <div>
        <button className="btn btn-light" type="button" onClick={this.openModal}><span role="img" aria-label="Select Entry Location">📁</span> {this.props.label}</button>
        <Modal open={this.state.isOpen} onClose={this.closeModal} styles={style} animationDuration={0} showCloseIcon={false} center>
          <div style={{marginTop: "15px", height: "380px", overflow: "auto"}}>
            {this.props.children}
          </div>
          <button type="button" className="btn btn-primary" onClick={this.closeModal} style={{width: "100%", margin: "20px 0px 5px 0px"}}>Select</button>
        </Modal>
      </div>
    )
  }
}

export default LocationModal;


// WEBPACK FOOTER //
// ./src/Components/SiteManagement/LocationModal.js